import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import AgentTopHeadScreen from "../../component/layout/agent-header";
import AgentSidebarScreen from "../../component/layout/agent-sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import ProfileImg1 from "@/../../public/images/profile-lg-1.jpg";
import { FaChevronDown } from "react-icons/fa6";
import { LuDownload } from "react-icons/lu";
import { useLocation } from "react-router-dom";
import {
  applicantListAsPerJobAgent,
} from "../../service/apis/auth.api";
import _ from "lodash";
import DataTable from "../../common/data-table";
import Loader from "../../common/Loader/loader";
import { showError } from "../../utils/Common";

const AgentApplicationsScreen = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const location = useLocation();
  const { jobId } = location.state || {};
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [applicantTableData, setApplicantTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const columns = [
    { label: "Applicant Id", key: "applicant_id" },
    { label: "Candidate Name", key: "name" },
    { label: "Applied Date", key: "applied_date" },
    { label: "Status", key: "status" },
    { label: "Actions", key: "actions" },
  ];

  useEffect(() => {
    fetchjobApplicantListTable(jobId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobId]);

  //applicant list for table formate
  const fetchjobApplicantListTable = async (
    jobId: string = "",
    page = 1,
    search = "",
    sortKey = "",
    sortDirection = "",
    itemsPerPage = 10
  ) => {
    try {
      setIsLoading(true);
      const response = await applicantListAsPerJobAgent(
        jobId,
        page,
        search,
        sortKey,
        sortDirection,
        itemsPerPage
      );
      const transformed = await transformedData(
        response?.applications?.applications
      );
      setApplicantTableData(transformed);
      setTotalPages(response?.applications?.totalPages);
      setCurrentPage(Number(response?.applications?.page));
    } catch (err: any) {
      showError(err?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const transformedData = async (applicants: any = []) => {
    return (
      applicants &&
      applicants?.map((app: any, index: number) => ({
        applicant_id: index + 1,
        name: app?.candidate?.name || "N/A",
        applied_date: app.createdAt
          ? new Date(app.createdAt).toLocaleDateString()
          : "N/A",
        status: _.startCase(_.toLower(app?.status)) || "N/A",

        actions: (
          <div>
            <Button
              className="btnnoStyle"
              variant="primary"
              onClick={() => downloadResume(app?.candidate?.resume)}
              disabled={!app?.candidate?.resume}
            >
              <LuDownload style={{ cursor: !app?.candidate?.resume ? "not-allowed" : "pointer",  opacity: !app?.candidate?.resume ? 0.5 : 1}}/>
            </Button>
          </div>
        ),
      }))
    );
  };

  const downloadResume = (resumeUrl: string = "") => {
    window.open(resumeUrl, "_blank");
  };

  const handlePageChange = (page: number) => {
    fetchjobApplicantListTable(jobId, page);
  };

  const handleSearch = (searchTerm: string) => {
    fetchjobApplicantListTable(jobId, 1, searchTerm); // Reset to the first page when searching
  };

  const handleSort = (key: string, direction: string) => {
    fetchjobApplicantListTable(jobId, 1, "", key, direction); // Reset to the first page when sorting
  };
  const handleItemsPerPageChange = (itemsPerPage: number) => {
    fetchjobApplicantListTable(jobId, 1, "", "", "", itemsPerPage); // Reset to the first page when items per page changes
  };
  return (
    <>
      <div className="main">
        <section className="profileJoblisting-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar position-relative p-0">
                <AgentSidebarScreen />
              </div>
              <div className="col-lg-10 rightcontent p-0">
                <AgentTopHeadScreen />
                <div className="profileJoblisting-holder rightInnerScroll">
                  <div className="row">
                    <div className="col-lg-12  position-relative">
                      <div className="applicants-holder d-flex justify-content-between mb-3">
                        <div className="title">
                          <h2>Applicants</h2>
                        </div>
                        {/* <div className="sortby-holder">
                                                    <h6>Sort By:</h6>
                                                    <Form.Select aria-label="Default select example">
                                                        <option>Applied</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </Form.Select>
                                                </div> */}
                      </div>

                      {/* <Tabs
                        defaultActiveKey="home"
                        id="uncontrolled-tab-example"
                        className="mb-3"
                      > */}
                      {/* <Tab eventKey="home" title="Home"> */}
                      <div className="listviewMain">
                        <div className="appliedJobsTable managejobtable">
                          <div className="table-responsive">
                            {isLoading ? (
                              <Loader />
                            ) : (
                              <DataTable
                                data={applicantTableData}
                                columns={columns}
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                                onSearch={handleSearch}
                                onSort={handleSort}
                                onItemsPerPageChange={handleItemsPerPageChange}
                              />
                            )}
                            {/* <Table>
                                  <thead>
                                    <tr>
                                      <th>Candidate Name</th>
                                      <th>Applied Date</th>
                                      <th>Status</th>

                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>
                                        <div className="profileholdertable d-flex">
                                          <div className="profileImg">
                                            <span>JD</span>
                                          </div>
                                          <p>John Doe</p>
                                        </div>
                                      </td>
                                      <td>Sep 15, 2024</td>
                                      <td>
                                        <button className="success">
                                          Applied <FaChevronDown />
                                        </button>
                                      </td>
                                      <td>Software Engineer</td>
                                      <td>Oct 12, 2024</td>
                                      <td>
                                        <button className="hireme">
                                          Hire Me
                                        </button>
                                      </td>
                                      <td>
                                        <ul>
                                          <li>
                                            <Button
                                              className="btnnoStyle"
                                              variant="primary"
                                            >
                                              <LuDownload />
                                            </Button>
                                          </li>
                                          <li>
                                            <Button
                                              className="btnnoStyle"
                                              variant="primary"
                                              onClick={handleShow}
                                            >
                                              <LuEye />
                                            </Button>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <AiOutlineDelete />
                                            </a>
                                          </li>
                                        </ul>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <div className="profileholdertable d-flex">
                                          <div className="profileImg">
                                            <span>JD</span>
                                          </div>
                                          <p>John Doe</p>
                                        </div>
                                      </td>
                                      <td>Sep 15, 2024</td>
                                      <td>
                                        <button className="success">
                                          Applied <FaChevronDown />
                                        </button>
                                      </td>
                                      <td>Software Engineer</td>
                                      <td>Oct 12, 2024</td>
                                      <td>
                                        <button className="hireme">
                                          Hire Me
                                        </button>
                                      </td>
                                      <td>
                                        <ul>
                                          <li>
                                            <Button
                                              className="btnnoStyle"
                                              variant="primary"
                                            >
                                              <LuDownload />
                                            </Button>
                                          </li>
                                          <li>
                                            <Button
                                              className="btnnoStyle"
                                              variant="primary"
                                              onClick={handleShow}
                                            >
                                              <LuEye />
                                            </Button>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <AiOutlineDelete />
                                            </a>
                                          </li>
                                        </ul>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <div className="profileholdertable d-flex">
                                          <div className="profileImg">
                                            <img
                                              src={ProfileImg1}
                                              alt="profile"
                                            />
                                          </div>
                                          <p>Alex Johnson</p>
                                        </div>
                                      </td>
                                      <td>Sep 15, 2024</td>
                                      <td>
                                        <button className="success">
                                          Applied <FaChevronDown />
                                        </button>
                                      </td>
                                      <td>Software Engineer</td>
                                      <td>Oct 12, 2024</td>
                                      <td>
                                        <button className="hireme">
                                          Hire Me
                                        </button>
                                      </td>
                                      <td>
                                        <ul>
                                          <li>
                                            <Button
                                              className="btnnoStyle"
                                              variant="primary"
                                            >
                                              <LuDownload />
                                            </Button>
                                          </li>
                                          <li>
                                            <Button
                                              className="btnnoStyle"
                                              variant="primary"
                                              onClick={handleShow}
                                            >
                                              <LuEye />
                                            </Button>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <AiOutlineDelete />
                                            </a>
                                          </li>
                                        </ul>
                                      </td>
                                    </tr>
                                  </tbody>
                                </Table> */}
                          </div>
                          {/* <div className="paginationholder align-left mb-5">
                                <Pagination>
                                  <Pagination.Prev />
                                  <Pagination.Item>{1}</Pagination.Item>
                                  <Pagination.Item active>{2}</Pagination.Item>
                                  <Pagination.Item>{3}</Pagination.Item>
                                  <Pagination.Ellipsis />
                                  <Pagination.Item>{6}</Pagination.Item>
                                  <Pagination.Next />
                                </Pagination>
                              </div> */}
                        </div>
                      </div>
                      {/* </Tab> */}
                      {/* <Tab eventKey="profile" title="Profile">
                                                    <div className="gridviewMain">
                                                        <Row>
                                                            <Col lg className="colour-blue">
                                                                <button className="btn w-100 btn-blue">Applied</button>
                                                                <div className="cardHolder">
                                                                    <Card className="kanban">
                                                                        <Card.Body>
                                                                            <div className="profileholdertable d-flex">
                                                                                <div className="profileImg"><span>PR</span></div>
                                                                                <h6>Paityn Rosser <span>Software Engineer</span></h6>
                                                                            </div>
                                                                            <div className="datelinks"><p>Sep 15, 2024</p>
                                                                                <ul className="d-flex">
                                                                                    <li><Button className="btnnoStyle" variant="primary"><LuDownload /></Button></li>
                                                                                    <li><Button className="btnnoStyle" variant="primary" onClick={handleShow}><LuEye /></Button></li>
                                                                                    <li><Button className="btnnoStyle text-red" variant="primary"><AiOutlineDelete /></Button></li>
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                    <Card className="kanban">
                                                                        <Card.Body>
                                                                            <div className="profileholdertable d-flex">
                                                                                <div className="profileImg"><img src={ProfileImg1} alt="profile" /></div>
                                                                                <h6>Maren Madsen <span>Software Engineer</span></h6>
                                                                            </div>
                                                                            <div className="datelinks"><p>Sep 15, 2024</p>
                                                                                <ul className="d-flex">
                                                                                    <li><Button className="btnnoStyle" variant="primary"><LuDownload /></Button></li>
                                                                                    <li><Button className="btnnoStyle" variant="primary" onClick={handleShow}><LuEye /></Button></li>
                                                                                    <li><Button className="btnnoStyle text-red" variant="primary"><AiOutlineDelete /></Button></li>
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                    <Card className="kanban">
                                                                        <Card.Body>
                                                                            <div className="profileholdertable d-flex">
                                                                                <div className="profileImg"><span>HS</span></div>
                                                                                <h6>Hanna Siphron <span>Software Engineer</span></h6>
                                                                            </div>
                                                                            <div className="datelinks"><p>Sep 15, 2024</p>
                                                                                <ul className="d-flex">
                                                                                    <li><Button className="btnnoStyle" variant="primary"><LuDownload /></Button></li>
                                                                                    <li><Button className="btnnoStyle" variant="primary" onClick={handleShow}><LuEye /></Button></li>
                                                                                    <li><Button className="btnnoStyle text-red" variant="primary"><AiOutlineDelete /></Button></li>
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                    <Card className="kanban">
                                                                        <Card.Body>
                                                                            <div className="profileholdertable d-flex">
                                                                                <div className="profileImg"><img src={ProfileImg1} alt="profile" /></div>
                                                                                <h6>Lydia Bator <span>Software Engineer</span></h6>
                                                                            </div>
                                                                            <div className="datelinks"><p>Sep 15, 2024</p>
                                                                                <ul className="d-flex">
                                                                                    <li><Button className="btnnoStyle" variant="primary"><LuDownload /></Button></li>
                                                                                    <li><Button className="btnnoStyle" variant="primary" onClick={handleShow}><LuEye /></Button></li>
                                                                                    <li><Button className="btnnoStyle text-red" variant="primary"><AiOutlineDelete /></Button></li>
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                </div>
                                                            </Col>
                                                            <Col lg className="colour-red">
                                                                <button className="btn w-100 btn-red">Rejected</button>
                                                                <div className="cardHolder">
                                                                    <Card className="kanban">
                                                                        <Card.Body>
                                                                            <div className="profileholdertable d-flex">
                                                                                <div className="profileImg"><span>PR</span></div>
                                                                                <h6>Paityn Rosser <span>Software Engineer</span></h6>
                                                                            </div>
                                                                            <div className="datelinks"><p>Sep 15, 2024</p>
                                                                                <ul className="d-flex">
                                                                                    <li><Button className="btnnoStyle" variant="primary"><LuDownload /></Button></li>
                                                                                    <li><Button className="btnnoStyle" variant="primary" onClick={handleShow}><LuEye /></Button></li>
                                                                                    <li><Button className="btnnoStyle text-red" variant="primary"><AiOutlineDelete /></Button></li>
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                    <Card className="kanban">
                                                                        <Card.Body>
                                                                            <div className="profileholdertable d-flex">
                                                                                <div className="profileImg"><img src={ProfileImg1} alt="profile" /></div>
                                                                                <h6>Maren Madsen <span>Software Engineer</span></h6>
                                                                            </div>
                                                                            <div className="datelinks"><p>Sep 15, 2024</p>
                                                                                <ul className="d-flex">
                                                                                    <li><Button className="btnnoStyle" variant="primary"><LuDownload /></Button></li>
                                                                                    <li><Button className="btnnoStyle" variant="primary" onClick={handleShow}><LuEye /></Button></li>
                                                                                    <li><Button className="btnnoStyle text-red" variant="primary"><AiOutlineDelete /></Button></li>
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                    <Card className="kanban">
                                                                        <Card.Body>
                                                                            <div className="profileholdertable d-flex">
                                                                                <div className="profileImg"><span>HS</span></div>
                                                                                <h6>Hanna Siphron <span>Software Engineer</span></h6>
                                                                            </div>
                                                                            <div className="datelinks"><p>Sep 15, 2024</p>
                                                                                <ul className="d-flex">
                                                                                    <li><Button className="btnnoStyle" variant="primary"><LuDownload /></Button></li>
                                                                                    <li><Button className="btnnoStyle" variant="primary" onClick={handleShow}><LuEye /></Button></li>
                                                                                    <li><Button className="btnnoStyle text-red" variant="primary"><AiOutlineDelete /></Button></li>
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                    <Card className="kanban">
                                                                        <Card.Body>
                                                                            <div className="profileholdertable d-flex">
                                                                                <div className="profileImg"><img src={ProfileImg1} alt="profile" /></div>
                                                                                <h6>Lydia Bator <span>Software Engineer</span></h6>
                                                                            </div>
                                                                            <div className="datelinks"><p>Sep 15, 2024</p>
                                                                                <ul className="d-flex">
                                                                                    <li><Button className="btnnoStyle" variant="primary"><LuDownload /></Button></li>
                                                                                    <li><Button className="btnnoStyle" variant="primary" onClick={handleShow}><LuEye /></Button></li>
                                                                                    <li><Button className="btnnoStyle text-red" variant="primary"><AiOutlineDelete /></Button></li>
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                </div>
                                                            </Col>
                                                            <Col lg className="colour-light-orange">
                                                                <button className="btn w-100 btn-light-orange">Shortlisted</button>
                                                                <div className="cardHolder">
                                                                    <Card className="kanban">
                                                                        <Card.Body>
                                                                            <div className="profileholdertable d-flex">
                                                                                <div className="profileImg"><span>HS</span></div>
                                                                                <h6>Hanna Siphron <span>Software Engineer</span></h6>
                                                                            </div>
                                                                            <div className="datelinks"><p>Sep 15, 2024</p>
                                                                                <ul className="d-flex">
                                                                                    <li><Button className="btnnoStyle" variant="primary"><LuDownload /></Button></li>
                                                                                    <li><Button className="btnnoStyle" variant="primary" onClick={handleShow}><LuEye /></Button></li>
                                                                                    <li><Button className="btnnoStyle text-red" variant="primary"><AiOutlineDelete /></Button></li>
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                    <Card className="kanban">
                                                                        <Card.Body>
                                                                            <div className="profileholdertable d-flex">
                                                                                <div className="profileImg"><img src={ProfileImg1} alt="profile" /></div>
                                                                                <h6>Lydia Bator <span>Software Engineer</span></h6>
                                                                            </div>
                                                                            <div className="datelinks"><p>Sep 15, 2024</p>
                                                                                <ul className="d-flex">
                                                                                    <li><Button className="btnnoStyle" variant="primary"><LuDownload /></Button></li>
                                                                                    <li><Button className="btnnoStyle" variant="primary" onClick={handleShow}><LuEye /></Button></li>
                                                                                    <li><Button className="btnnoStyle text-red" variant="primary"><AiOutlineDelete /></Button></li>
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                </div>
                                                            </Col>
                                                            <Col lg className="colour-orange">
                                                                <button className="btn w-100 btn-orange">Interview</button>
                                                                <div className="cardHolder">
                                                                    <Card className="kanban">
                                                                        <Card.Body>
                                                                            <div className="profileholdertable d-flex">
                                                                                <div className="profileImg"><img src={ProfileImg1} alt="profile" /></div>
                                                                                <h6>Lydia Bator <span>Software Engineer</span></h6>
                                                                            </div>
                                                                            <div className="datelinks"><p>Sep 15, 2024</p>
                                                                                <ul className="d-flex">
                                                                                    <li><Button className="btnnoStyle" variant="primary"><LuDownload /></Button></li>
                                                                                    <li><Button className="btnnoStyle" variant="primary" onClick={handleShow}><LuEye /></Button></li>
                                                                                    <li><Button className="btnnoStyle text-red" variant="primary"><AiOutlineDelete /></Button></li>
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                </div>
                                                            </Col>
                                                            <Col lg className="colour-light-green">
                                                                <button className="btn w-100 btn-light-green">Offered</button>
                                                                <div className="cardHolder">
                                                                    <Card className="kanban">
                                                                        <Card.Body>
                                                                            <div className="profileholdertable d-flex">
                                                                                <div className="profileImg"><img src={ProfileImg1} alt="profile" /></div>
                                                                                <h6>Maren Madsen <span>Software Engineer</span></h6>
                                                                            </div>
                                                                            <div className="datelinks"><p>Sep 15, 2024</p>
                                                                                <ul className="d-flex">
                                                                                    <li><Button className="btnnoStyle" variant="primary"><LuDownload /></Button></li>
                                                                                    <li><Button className="btnnoStyle" variant="primary" onClick={handleShow}><LuEye /></Button></li>
                                                                                    <li><Button className="btnnoStyle text-red" variant="primary"><AiOutlineDelete /></Button></li>
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                    <Card className="kanban">
                                                                        <Card.Body>
                                                                            <div className="profileholdertable d-flex">
                                                                                <div className="profileImg"><span>HS</span></div>
                                                                                <h6>Hanna Siphron <span>Software Engineer</span></h6>
                                                                            </div>
                                                                            <div className="datelinks"><p>Sep 15, 2024</p>
                                                                                <ul className="d-flex">
                                                                                    <li><Button className="btnnoStyle" variant="primary"><LuDownload /></Button></li>
                                                                                    <li><Button className="btnnoStyle" variant="primary" onClick={handleShow}><LuEye /></Button></li>
                                                                                    <li><Button className="btnnoStyle text-red" variant="primary"><AiOutlineDelete /></Button></li>
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                    <Card className="kanban">
                                                                        <Card.Body>
                                                                            <div className="profileholdertable d-flex">
                                                                                <div className="profileImg"><img src={ProfileImg1} alt="profile" /></div>
                                                                                <h6>Lydia Bator <span>Software Engineer</span></h6>
                                                                            </div>
                                                                            <div className="datelinks"><p>Sep 15, 2024</p>
                                                                                <ul className="d-flex">
                                                                                    <li><Button className="btnnoStyle" variant="primary"><LuDownload /></Button></li>
                                                                                    <li><Button className="btnnoStyle" variant="primary" onClick={handleShow}><LuEye /></Button></li>
                                                                                    <li><Button className="btnnoStyle text-red" variant="primary"><AiOutlineDelete /></Button></li>
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                </div>
                                                            </Col>
                                                            <Col lg className="colour-green">
                                                                <button className="btn w-100 btn-green">Hired</button>
                                                                <div className="cardHolder">
                                                                    <Card className="kanban">
                                                                        <Card.Body>
                                                                            <div className="profileholdertable d-flex">
                                                                                <div className="profileImg"><span>PR</span></div>
                                                                                <h6>Paityn Rosser <span>Software Engineer</span></h6>
                                                                            </div>
                                                                            <div className="datelinks"><p>Sep 15, 2024</p>
                                                                                <ul className="d-flex">
                                                                                    <li><Button className="btnnoStyle" variant="primary"><LuDownload /></Button></li>
                                                                                    <li><Button className="btnnoStyle" variant="primary" onClick={handleShow}><LuEye /></Button></li>
                                                                                    <li><Button className="btnnoStyle text-red" variant="primary"><AiOutlineDelete /></Button></li>
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                    <Card className="kanban">
                                                                        <Card.Body>
                                                                            <div className="profileholdertable d-flex">
                                                                                <div className="profileImg"><img src={ProfileImg1} alt="profile" /></div>
                                                                                <h6>Maren Madsen <span>Software Engineer</span></h6>
                                                                            </div>
                                                                            <div className="datelinks"><p>Sep 15, 2024</p>
                                                                                <ul className="d-flex">
                                                                                    <li><Button className="btnnoStyle" variant="primary"><LuDownload /></Button></li>
                                                                                    <li><Button className="btnnoStyle" variant="primary" onClick={handleShow}><LuEye /></Button></li>
                                                                                    <li><Button className="btnnoStyle text-red" variant="primary"><AiOutlineDelete /></Button></li>
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                    <Card className="kanban">
                                                                        <Card.Body>
                                                                            <div className="profileholdertable d-flex">
                                                                                <div className="profileImg"><span>HS</span></div>
                                                                                <h6>Hanna Siphron <span>Software Engineer</span></h6>
                                                                            </div>
                                                                            <div className="datelinks"><p>Sep 15, 2024</p>
                                                                                <ul className="d-flex">
                                                                                    <li><Button className="btnnoStyle" variant="primary"><LuDownload /></Button></li>
                                                                                    <li><Button className="btnnoStyle" variant="primary" onClick={handleShow}><LuEye /></Button></li>
                                                                                    <li><Button className="btnnoStyle text-red" variant="primary"><AiOutlineDelete /></Button></li>
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                    <Card className="kanban">
                                                                        <Card.Body>
                                                                            <div className="profileholdertable d-flex">
                                                                                <div className="profileImg"><img src={ProfileImg1} alt="profile" /></div>
                                                                                <h6>Lydia Bator <span>Software Engineer</span></h6>
                                                                            </div>
                                                                            <div className="datelinks"><p>Sep 15, 2024</p>
                                                                                <ul className="d-flex">
                                                                                    <li><Button className="btnnoStyle" variant="primary"><LuDownload /></Button></li>
                                                                                    <li><Button className="btnnoStyle" variant="primary" onClick={handleShow}><LuEye /></Button></li>
                                                                                    <li><Button className="btnnoStyle text-red" variant="primary"><AiOutlineDelete /></Button></li>
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Tab> */}
                      {/* </Tabs> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />

      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="findajobmodal"
        centered
      >
        <Modal.Body>
          <div className="afterapplied">
            <div className="aplyinfo">
              <div className="profileholdertable mb-4 large d-flex">
                <div className="d-flex align-items-center">
                  <div className="profileImg">
                    <img src={ProfileImg1} alt="profile" />
                  </div>
                  <div className="ppname">
                    <h4>Michael Brown</h4>
                    <button className="success">
                      Applied <FaChevronDown />
                    </button>
                  </div>
                </div>
                <div className="downloadcv">
                  <Button className="btnnoStyle" variant="primary">
                    <LuDownload />
                  </Button>
                </div>
              </div>
              <h4>
                <strong>Candidate Name:</strong> Michael Brown
              </h4>
              <h4>
                <strong>Email Address:</strong> michaelbrown001@gmail.com
              </h4>
              <h4>
                <strong>Phone Number:</strong> (123)-456 7890
              </h4>
              <h4>
                <strong>Applied Date:</strong> Oct 12, 2024
              </h4>
              <h4>
                <strong>Position Applied For:</strong> Software Engineer
              </h4>
              <h4>
                <strong>Post Date: </strong> Applied
              </h4>
              <h4>
                <strong>Experience Level:</strong> 3+ years
              </h4>
              <div className="flex-btn d-flex">
                <Button className="btn w-100" variant="primary">
                  Hire Me
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default AgentApplicationsScreen;
